// src/v2/leases/LeaseNavPair.jsx
//
// LEASE-DETAIL-V5-S1: Compact prev/next lease navigator.
//
// Renders two pill buttons — "‹ Prev" and "Next ›" — immediately to the left
// of "Edit lease" in the sub-nav row (Zone 2 rightSlot). End-cap buttons are
// disabled at list boundaries. Height of the sub-nav row is unchanged.
//
// Props:
//   prevLeaseId — null when at the first position (disables Prev button)
//   nextLeaseId — null when at the last position (disables Next button)
//   onPrev      — () => void called when Prev is clicked
//   onNext      — () => void called when Next is clicked
//
// Right-alignment is handled at the DetailUnifiedBar rightSlot container level,
// not inside this component.

import React from "react";
import { T } from "../../app/tokens.js";
import { HairlineNavButton } from "../../components/HairlineNavButton.jsx";

export function LeaseNavPair({ prevLeaseId, nextLeaseId, onPrev, onNext }) {
  if (prevLeaseId === null && nextLeaseId === null) return null;

  return (
    <div
      data-testid="lease-detail-pager"
      style={{
        display:     "inline-flex",
        alignItems:  "center",
        gap:          6,
        paddingLeft:  14,
        borderLeft:  `1px solid ${T.planCompBorder}`,
      }}
    >
      <HairlineNavButton
        label="‹ Prev"
        onClick={onPrev}
        testId="lease-detail-prev"
        disabled={!prevLeaseId}
      />
      <HairlineNavButton
        label="Next ›"
        onClick={onNext}
        testId="lease-detail-next"
        disabled={!nextLeaseId}
      />
    </div>
  );
}
